import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import * as TrinityAPI from "../requests/TrinityAPI"
import { useStore } from "../stores/RootStoreContext"
import { IModalMessage } from "../types/error/IModalMessage"
import { ModalPopUp } from "./common/element/ModalPopUp"

export const Confirm = () => {
  const { userStore } = useStore()
  const params = useParams()
  const navigate = useNavigate()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)

  useEffect(() => {
    if (params.userId && params.confirmation) {
      TrinityAPI.confirm(Number(params.userId), params.confirmation, response => {
        if (response.status === 200) {
          userStore.setToken(response.data.token)
          navigate("/dashboard")
        } else {
          setModalMessage({
            title: "Ошибка!",
            text: "Ошибка подтверждения учетной записи: " + response.data.message
          })
        }
      })
    }
  })

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
    </>
  )
}
